<template>
  <div class="pn-score-container">
    <div class="pn-text">PN count</div>
    <div class="pn-score">
      {{ pnText }}
    </div>

  </div>

</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'PnScore',
  props: {
    well: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      getPnCount: 'timelapse/getPnCount',
      getPnText: 'timelapse/getPnText',
      getPnHazard: 'timelapse/getPnHazard'
    }),
    pnCount() {
      return this.getPnCount(this.well)
    },
    noPnCount() {
      return this.pnCount === null
    },
    pnText() {
      const pnt = this.getPnText(this.well)
      console.log(pnt)
      return this.getPnText(this.well)
    },
    pnHazard() {
      return this.getPnHazard(this.well)
    },
    isHealthy() {
      return !this.noPnCount && !this.pnHazard
    }
  }
}
</script>

<style lang="scss" scoped>
.pn-score-container {
  font-size: 9pt;
  background-color: $dark-4;
  border-radius: $border-radius;
  flex-direction: column;
  justify-content: center;
  display: flex
}

.pn-text {
  display: flex;
  justify-content: center;
}

.pn-score {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11pt;
  font-weight: 600;
  background-color: $dark-4;
  border-radius: $border-radius;

}
</style>
